export enum WebSocketClientMessageTypes {
  INVALID_TOKEN = 'INVALID_TOKEN',
  DOCUMENT_VERIFICATIONS_UPDATED = 'DOCUMENT_VERIFICATIONS_UPDATED',
  SMS_MESSAGE_STATUS_UPDATED = 'SMS_MESSAGE_STATUS_UPDATED',
  DOT_VERICATION_IMAGE_UPDATED = 'DOT_VERICATION_IMAGE_UPDATED',
}

export const webSocketClientAllMessages = [
  WebSocketClientMessageTypes.INVALID_TOKEN,
  WebSocketClientMessageTypes.DOCUMENT_VERIFICATIONS_UPDATED,
  WebSocketClientMessageTypes.SMS_MESSAGE_STATUS_UPDATED,
  WebSocketClientMessageTypes.DOT_VERICATION_IMAGE_UPDATED,
];
